exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* :host /deep/ lets shadowdom style child elements */\n:host /deep/ {\n  /**\n    * CSS Overrides for bug fixes\n    */\n  /**\n    * END CSS Overrides for bug fixes\n    */\n  /* Manage list custom styles */ }\n  :host /deep/ .md-sort-item /deep/ .md-list-item-content {\n    padding: 0; }\n  :host /deep/ .md-sort-icon {\n    font-size: 15px;\n    margin-right: 10px; }\n  :host /deep/ .md-sort-header {\n    padding: 10px; }\n    :host /deep/ .md-sort-header:hover {\n      background-color: #EEEEEE;\n      cursor: pointer; }\n  :host /deep/ .cards-no-gaps md-card:not(:first-child) {\n    margin-top: -8px !important; }\n  :host /deep/ .bg-grey {\n    background-color: #bdbdbd; }\n  :host /deep/ .bg-blue {\n    background-color: #3B5588; }\n  :host /deep/ .bg-red {\n    background-color: #DC4040; }\n  :host /deep/ .color-white {\n    color: #fff; }\n    :host /deep/ .color-white.mat-button {\n      color: #fff; }\n  :host /deep/ .fs18 {\n    font-size: 18px; }\n    :host /deep/ .fs18 .mat-select-trigger {\n      font-size: 18px; }\n\n.active {\n  background-color: lightgray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 0